import request from '@/utils/request'
//学科列表
export function getSubject(data) {
  return request({
    url: '/app/course/selectSubjectAppByschoolId',
    method: 'post',
    data
  })
}
//年级列表

export function getSelectSchool(data) {
    return request({
      url: '/app/course/selectSchoolGradeByschoolId',
      method: 'post',
      data
    })
  }

  //查询视频列表

  export function getTeacherIdAndStart(data) {
    return request({
      url: '/app/course/courseByTeacherIdAndStart',
      method: 'post',
      data
    })
  }

   //学生查询视频列表

   export function getStudentIdAndStart(data) {
    return request({
      url: '/app/course/selectAllSubjectBySubjectIdAndSchoolId',
      method: 'post',
      data
    })
  }

  export function downloadVideo(params) {
    return request({
      url: '/app/onlinecourse/downloadVideo',
      params
    })
  }


    
 